
import './App.css';
import Academy from './components/academy';
import Certificate from './components/certificate';
import Labor  from './components/labor';
import PersonalData from './components/personalData';

function App() {
  return (
    <div className="App">
      <header className="App-header">
        <h1>
          RESUME
        </h1>
        <PersonalData className='Personal-Data'/>
        <Academy className='Academy'/>
        <Labor className='Labor'/>
        <Certificate className='Certificate'/>
      </header>
      <footer className='App-footer'>
      <h2>Contact</h2>
      <a href='https://forms.gle/PBHVcw2atxGcT6ae6' target='_blank' rel='noreferrer'><img src='https://1000marcas.net/wp-content/uploads/2019/11/Logo-Gmail.jpg' alt='whats app contact'></img></a>
      </footer>
    </div>
  );
}

export default App;
